// then define an Icon component that references the
import { SVGProps } from 'react';

// keep a list of the icon ids we put in the symbol
export type IconId =
    | 'facebook'
    | 'instagram'
    | 'youtube'
    | 'linkedin'
    | 'full-star'
    | 'half-star'
    | 'empty-star'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'chevron-down'
    | 'circle'
    | 'cross'
    | 'close'
    | 'tick'
    | 'pause'
    | 'play'
    | 'reset'
    | 'outline-check'
    | 'map-marker'
    | 'spinner'
    | 'question'
    | 'alert'
    | 'plus'
    | 'upload';

export function Icon({ id, ...props }: { id: IconId } & SVGProps<SVGSVGElement>) {
    return (
        <svg key={id} {...props}>
            <use href={`/svg/icons.svg#${id}`} />
        </svg>
    );
}
